import React, { useCallback, useEffect, useState } from "react";
import Info from "../../components/InfoCard/Info";
import { FaWallet } from "react-icons/fa";
import { CgCircleci } from "react-icons/cg";
import style from "./Tickets.module.scss";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadTickets } from "../../redux/admin/actions/admin.actions";
import { constructOrderDate } from "../../helper/DateFormatter";
import { LinearLoader } from "../../components/Loader/LinearLoader";
// import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import Pagination from "../../components/paginationCopy/Pagination";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import CloseTicket from "./CloseTicket";
import { Zoom } from "react-reveal";
import { SortButton } from "../../components/utils/sortButton";

const Customer = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [ticketModal, setTicketModal] = useState(false);
  const [dataMatch, setDataMatch] = useState();
  const { ticket } = useSelector((state) => state.adminReducer);
  let tickets = ticket?.data;

  useEffect(() => {
    setLoading(true);
    dispatch(loadTickets());
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRow = (data) => {
    data?.status === "open" && setTicketModal(true);
    // let complain;
    let match = tickets?.find((t) => t?.id === data?.id);
    if (match) {
      setDataMatch(match);
    }
    // return complain;
  };

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const size = 10;
  const pagesVisited = pageNumber * size;
  const pageCount = Math.ceil(tickets?.length / size);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // sorting
  const [sortKey, setSortKey] = useState("tym");
  const [sortOrder, setSortOrder] = useState("desc");

  function sortData({ tableData, sortKey, reverse }) {
    if (!sortKey) return tableData;

    const sortedData = tickets?.sort((a, b) => {
      return a[sortKey] > b[sortKey] ? 1 : -1;
    });

    if (reverse) {
      return sortedData?.reverse();
    }

    return sortedData;
  }

  const sortedData = useCallback(
    () =>
      sortData({ tableData: tickets, sortKey, reverse: sortOrder === "desc" }),
    [tickets, sortKey, sortOrder]
  );

  const headers = [
    { key: "index", label: "S/N" },
    { key: "name", label: "Hospital Name" },
    { key: "description", label: "Subjects" },
    { key: "status", label: "Status" },
    { key: "priority", label: "Priority" },
    { key: "tym", label: "Date" },
  ];

  const changeSort = (key) => {
    setSortOrder(sortOrder === "ascn" ? "desc" : "ascn");
    setSortKey(key);
  };
  return (
    <>
      <Zoom>
        <div className={style.container}>
          <Info
            bgColor={"#fff"}
            color={"#950303"}
            // percentage={"41%"}
            icon={<FaWallet />}
            value={ticket?.total}
            cardText={"Total Tickets"}
          />
          <Info
            bgColor={"#fff"}
            color={"#78A55A"}
            // percentage={"11%"}
            icon={<FaWallet />}
            value={ticket?.open}
            cardText={ticket?.open > 1 ? "Open Tickets" : "Open Ticket"}
          />
          <Info
            bgColor={"#fff"}
            color={"#FBA243"}
            // percentage={"08%"}
            icon={<FaWallet />}
            value={ticket?.pending}
            cardText={
              ticket?.pending > 1 ? "Pending Tickets" : "Pending Ticket"
            }
          />
          {/* <Info2 /> */}
        </div>
      </Zoom>
      <section style={{ maxWidth: "95%", margin: "auto" }}>
        {loading && <LinearLoader />}
        <Table borderless responsive className="mt-4" hover>
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return (
                  <td key={row.key}>
                    {row.label}{" "}
                    <SortButton
                      columnKey={row.key}
                      onClick={() => changeSort(row.key)}
                      {...{ sortOrder, sortKey }}
                    />
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {sortedData()
              ?.slice(pagesVisited, pagesVisited + size)
              ?.map((tick, index) => (
                <tr
                  className={style.tableBodyRow}
                  key={index}
                  onClick={() => handleRow(tick)}
                >
                  <td>{pageNumber * size + index + 1}</td>
                  <td style={{ width: "20vw" }}>{tick?.name}</td>
                  <td style={{ width: "30vw" }}>{tick?.description}</td>
                  <td style={{ width: "10vw" }}>
                    {" "}
                    <div
                      className={`${style.status} ${style.close}`}
                      style={
                        tick?.status === "open"
                          ? { color: "#3BC34E" }
                          : tick?.status === "pending"
                          ? { color: "#EBAF16" }
                          : { color: "#DD3D43" }
                      }
                    >
                      <span className="me-2">
                        <CgCircleci />
                      </span>
                      {tick?.status === "good" ? "closed" : tick?.status}
                    </div>
                  </td>
                  <td>
                    <div className={style.priority}> {tick?.priority}</div>
                  </td>
                  <td>{constructOrderDate(tick?.tym)}</td>
                </tr>
              ))}
          </tbody>
        </Table>
        {tickets?.length > size && (
          <Pagination pageCount={pageCount} onPageChange={changePage} />
        )}
      </section>

      {/* DIALOG MODAL */}
      <ConfirmationModal
        open={ticketModal}
        handleClose={() => setTicketModal(false)}
        closemodal={() => setTicketModal(false)}
        bgcolor="white"
        width="40vw"
        instruction={
          // <UpdateTicket
          //   onClick={() => setTicketModal(false)}
          //   id={dataMatch?.id}
          //   hospital={dataMatch?.name}
          //   description={dataMatch?.description}
          //   priority={dataMatch?.priority}
          //   assign={dataMatch?.assign}
          //   reason={dataMatch?.reason}
          // />

          <CloseTicket
            id={dataMatch?.id}
            onClickYes={() => setTicketModal(false)}
          />
        }
      />
    </>
  );
};

export default Customer;
